import {API_ENDPOINTS} from "./endpoints.js";
import {createHeaders, performRequest} from "./api.js";

export const queryDeviceList = async (query, abortSignal) => {
    const options = {
        method: "GET",
        headers: await createHeaders(),
        signal: abortSignal
    };
    const queryString = Object.keys(query)
        .filter(key => query[key]) // only query if truthy value
        .map((key) => `${key}=${query[key]}`).join("&");
    return performRequest(`${API_ENDPOINTS.QUERY_LIST_DEVICES}?${queryString}`, options);
};

export const queryDeviceAggregates = async (query, abortSignal) => {
    const options = {
        method: "GET",
        headers: await createHeaders(),
        signal: abortSignal
    };
    const queryString = Object.keys(query)
        .filter(key => query[key])
        .map((key) => `${key}=${query[key]}`).join("&");
    return performRequest(`${API_ENDPOINTS.API_BASE}/api/device/aggregates?${queryString}`, options);
};
